import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentState } from '../../types';

const initialState: PaymentState = {
  reimbursementRef: '',
  clientSecret: '',
  amount: 0,
  discountedAmount: 0,
  paymentMethod: '',
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setReimbursementRef: (state, action: PayloadAction<string>) => {
      state.reimbursementRef = action.payload;
    },
    setClientSecret: (state, action: PayloadAction<string>) => {
      state.clientSecret = action.payload;
    },
    setPaymentAmount: (state, action: PayloadAction<{ amount: number; discountedAmount?: number }>) => {
      state.amount = action.payload.amount;
      state.discountedAmount = action.payload.discountedAmount ?? action.payload.amount;
    },
    setPaymentMethod: (state, action: PayloadAction<string>) => {
      state.paymentMethod = action.payload;
    },
    setPaymentData: (
      state,
      action: PayloadAction<{
        reimbursementRef: string;
        clientSecret: string;
        amount: number;
        discountedAmount?: number;
      }>
    ) => {
      state.reimbursementRef = action.payload.reimbursementRef;
      state.clientSecret = action.payload.clientSecret;
      state.amount = action.payload.amount;
      state.discountedAmount = action.payload.discountedAmount ?? action.payload.amount;
    },
    resetPayment: () => initialState,
  },
});

export const {
  setReimbursementRef,
  setClientSecret,
  setPaymentAmount,
  setPaymentMethod,
  setPaymentData,
  resetPayment,
} = paymentSlice.actions;
export default paymentSlice.reducer;

